import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { PhotoCollection } from '../../models/serializable/photo-collection.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class ServicePhotosComponent extends Component {
  static readonly TYPE_ID: string = '462eb9dd080e497296d3c9835217fac1';

  constructor(
        public readonly photos: PhotoCollection,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return ServicePhotosComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ServicePhotosComponent {
    return new ServicePhotosComponent(
        context.fromData<PhotoCollection>(MapUtils.get<SerializedData>(map, 'photos')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'photos': context.toData(this.photos),
    };
  }

  clone(): this {
    return new ServicePhotosComponent(
        this.photos.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.photos, this.photos);
  }
}

export class ServicePhotosComponentBuilder extends DataModelBuilder<ServicePhotosComponent> {
  build(context: SerializationContext, map: SerializedData): ServicePhotosComponent {
    return ServicePhotosComponent.fromMap(context, map);
  }
}
